import React from 'react';
import { Box, Button, Divider, Paper, SvgIcon, Typography } from '../../../elements';
import { Container, Title } from './Step.style';
import { t } from '../../../../../js/common/translations';

const LastStep = ({ apartmentsPath, homePath, visitForm, propertyAddress, locale }) => {
  const date = new Date(visitForm.date);
  const optionsDate = {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  };
  return (
    <Container>
      <Paper sx={{ padding: '24px', maxWidth: { xs: '100%', md: '575px' } }}>
        <Box>
          <Title>{t('visit_form.last_step.title')}</Title>
          <Typography sx={{ fontSize: '20px', mb: '32px' }}>{t('visit_form.last_step.subtitle')}</Typography>
          <Typography sx={{ fontSize: '20px', mb: '8px' }}>{t('visit_form.last_step.visit_details')}</Typography>
          <Box display='flex'>
            <SvgIcon name="calendar" sx={{ m: '1rem', mr: '1.5rem' }} size="25" />
            <Box display="flex" sx={{ flexDirection: 'column', mb: '1rem' }}>
              <Typography fontSize="14px" sx={{ mb: '4px' }}>{t('visit_form.last_step.day_period')}</Typography>
              <Typography fontSize="20px">{date.toLocaleString(locale, optionsDate)} - {visitForm.time}</Typography>
            </Box>
          </Box>
          <Box display='flex' sx={{ mb: '32px' }}>
            <SvgIcon name="location_bookings" sx={{ m: '1rem', mr: '1.5rem' }} size="25" />
            <Box display="flex" sx={{ flexDirection: 'column' }}>
              <Typography fontSize="14px" sx={{ mb: '4px' }}>{t('visit_form.last_step.address')}</Typography>
              <Typography fontSize="20px">{propertyAddress}</Typography>
            </Box>
          </Box>
          <Divider sx={{ mt: '32px' }} />
          <Box display="flex" sx={{ mt: '24px' }}>
            <Button size="large" href={homePath} variant='outlined' sx={{ width: '100%', mr: '0.75rem' }}>{t('visit_form.back_to_homepage')}</Button>
            <Button size="large" href={apartmentsPath} sx={{ width: '100%', ml: '0.75rem', textAlign: 'center' }}>{t('visit_form.last_step.search_more')}</Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default LastStep;
